import DraftOrderConfirmPage from '../../components/pages/draft_orders/DraftOrderConfirmPage'
export default {
  components: { DraftOrderConfirmPage }
}
